import { postForm } from '@/utils/request'

const BASE_URL = '/marketingIntl/brand/advertise/'
const GET_AD_ENUM = BASE_URL + 'enum'
const GET_AD_CONFIG = BASE_URL + 'config'
const GET_AD_LIST = BASE_URL + 'list'
const GET_AD_FAQ = BASE_URL + 'faq'
const GET_SHOP_LIST = BASE_URL + 'shopList'
const GET_AD_DETAIL = BASE_URL + 'detail'
const GET_OPERATE = BASE_URL + 'operate'
const GET_SHOP_RECORD = BASE_URL + 'shopRecord'
const UPDATE_STATUS = BASE_URL + 'updateStatus'
const CREATE_ADVERTISE = BASE_URL + 'create'
const EDIT_ADVERTISE = BASE_URL + 'edit'
const ADVERTISE_MERCHANTS_PLAN_DETAIL = BASE_URL + 'merchantsPlanDetail'
const ADVERTISE_MERCHANTS_PLAN_JOIN = BASE_URL + 'joinMerchantsPlan'
const GET_BRAND_LIST = '/marketingIntl/brand/brands'
const GET_BRAND_SHOP_TREE = '/marketingIntl/brand/brandShopTree'

// 获取公共枚举
export async function getAdEnum(params) {
  return postForm(GET_AD_ENUM, params)
}

// 广告配置
export async function getAdConfig(params) {
  return postForm(GET_AD_CONFIG, params)
}

// 广告计划列表
export async function getAdList(params) {
  return postForm(GET_AD_LIST, params)
}

// 广告FAQ
export async function getAdFaq(params) {
  return postForm(GET_AD_FAQ, params)
}

// 店铺列表
export async function getAdShopList(params) {
  return postForm(GET_SHOP_LIST, params)
}

// 广告计划详情
export async function getAdDetail(params) {
  return postForm(GET_AD_DETAIL, params)
}

// 店铺参与记录
export async function getShopRecord(params) {
  return postForm(GET_SHOP_RECORD, params)
}

// 操作列表
export async function getOperation(params) {
  return postForm(GET_OPERATE, params)
}

// 广告计划状态变更
export async function updateStatus(params) {
  return postForm(UPDATE_STATUS, params)
}

// 创建广告计划
export async function createAd(params) {
  return postForm(CREATE_ADVERTISE, params)
}

// 编辑广告计划
export async function editAd(params) {
  return postForm(EDIT_ADVERTISE, params)
}

// 广告招商详情
export async function getAdMerchantsDetail(params) {
  return postForm(ADVERTISE_MERCHANTS_PLAN_DETAIL, params)
}

// 报名参与广告招商
export async function joinAdMerchantsPlan(params) {
  return postForm(ADVERTISE_MERCHANTS_PLAN_JOIN, params)
}

// 获取品牌列表
export async function getBrandList(params) {
  return postForm(GET_BRAND_LIST, params)
}

// 获取品牌门店树状结构
export async function getBrandShopTree(params) {
  return postForm(GET_BRAND_SHOP_TREE, params)
}
